<template>
  <div>

    <!-- <div class="container cover-global">
      <div class="content text-center">
        <h2 class="title">{{ $t('servers') }}</h2>
        <p class="describe">{{ $t('lighteningSpeed') }}</p>
        <p class="map-box">
          <img src="/static/img/home/map_2x.png" :alt="$t('servers')">
        </p>
      </div>
    </div>

    <triangle :top-color="'transparent'" :right-color="'#F2F5FC'"></triangle>
    <div class="container easy-to-use">
      <div class="content">
        <div class="phone-show">
          <h2>{{ $t('noNeedSetting') }}</h2>
          <div>
            <img src="/static/img/home/ios-screenshots.png" alt="One click connection, do not need to set up">
          </div>
          <p class="describe">{{ $t('noTerminology') }}{{ $t('clickContact') }}</p>
          <gradient-btn class="gradient-btn-component" :link-url="'/download'" :width="'2rem'" :height="'.54rem'" :border-radius="'.54rem'" :fontSize="'.2rem'">{{ $t('download') }}</gradient-btn>
        </div>
        <p class="clearfix"></p>
      </div>
    </div>
    <triangle :top-color="'#F2F5FC'" :right-color="'transparent'"></triangle>

    <div class="container stable-quicken">
      <div class="content">
        <div>
          <h2 class="text-center">{{ $t('noBandwidthCharge') }}</h2>
          <div class="text-center">
            <span><svg class="icon rocket-icon"><use xlink:href="#icon-rocket"></use></svg></span>
          </div>
          <h3>{{ $t('breakBandwidth') }}</h3>
          <p class="describe">{{ $t('advancedTechnique') }}</p>
        </div>
      </div>
    </div>

    <div class="container safe">
      <div class="content">
        <div class="vertical-middle">
          <h2 class="text-center">{{ $t('dataEncryption') }}</h2>
          <div class="text-center">
            <span><svg class="icon shield-icon"><use xlink:href="#icon-shield"></use></svg></span>
          </div>
          <h3>{{ $t('respectPrivacy') }}</h3>
          <p class="describe">{{ $t('encryptInfo') }}</p>
        </div>
      </div>
    </div> -->
    <div class="banner-center">


    <div class="container stable-quicken">
      <div class="content content-bottom">
        <div class="vertical-middle text-left">
          <img src="/static/img/newhome_img/content1copy.png" class="circle-img" alt="">
          <!-- <span><svg class="icon rocket-icon"><use xlink:href="#icon-rocket"></use></svg></span> -->
        </div>
         <div class="vertical-middle text-right">
          <h2>{{ $t('visitglobal') }}</h2>

          <p>{{ $t('visitcontent1') }}</p>

           <div  @click="getNow()">
            {{ $t('getNow') }}
          </div>
        </div>


      </div>
    </div>

    <div class="container safe">
      <div class="content content-bottom">
         <div class="vertical-middle text-left">
          <img src="/static/img/newhome_img/content2copy.png" alt="">
          <!-- <span><svg class="icon shield-icon"><use xlink:href="#icon-shield"></use></svg></span> -->
        </div>
        <div class="vertical-middle text-right">
          <h2>{{ $t('privacyprotection') }}</h2>

          <p>{{ $t('privacycontent1') }}</p>
           <div @click="getNow()">

            {{ $t('getNow') }}
            </div>
        </div>

      </div>
    </div>

    <div class="container special">
      <div class="content">
        <ul class="special-lists">
          <li>
            <div class="spe-line"></div>
            <img src="/static/img/newhome_img/spe1-m.png" alt="">
              <div class="special-right">
              <h2>{{ $t('advantage1') }}</h2>
               <p>{{ $t('advantagecontent1') }}</p>
            </div>
            <hr>
          </li>
          <li>
            <div class="spe-line"></div>
            <img src="/static/img/newhome_img/spe2-m.png" alt="">
            <div class="special-right">
              <h2>{{ $t('advantage2') }}</h2>
               <p>{{ $t('advantagecontent2') }}</p>
            </div>
            <hr>
          </li>
          <li>
            <div class="spe-line"></div>
            <img src="/static/img/newhome_img/spe3-m.png" alt="">
            <div class="special-right">
              <h2>{{ $t('advantage3') }}</h2>
               <p>{{ $t('advantagecontent3') }}</p>
            </div>
            <hr>
          </li>
        </ul>
      </div>
    </div>

    <div class="container stable-quicken global">
      <div class="content">
        <div class="vertical-middle text-left">
          <img src="/static/img/newhome_img/newcontent4.jpg" class="computer-img" alt="">
          <!-- <span><svg class="icon rocket-icon"><use xlink:href="#icon-rocket"></use></svg></span> -->
        </div>
        <div class="vertical-middle">
          <h2>{{ $t('globalNote') }}</h2>

          <p class="text-content3">{{ $t('advantagecontent') }}</p>
          <div class="get-now" @click="getNow()">
            {{ $t('getNow') }}
          </div>
        </div>
      </div>
    </div>

    <div class="container stable-quicken">
      <div class="content">
        <div class="vertical-middle text-left">
          <img src="/static/img/newhome_img/content3.png" class="computer-img" alt="">
          <!-- <span><svg class="icon rocket-icon"><use xlink:href="#icon-rocket"></use></svg></span> -->
        </div>
        <div class="vertical-middle">
          <h2>{{ $t('multipleDevices') }}</h2>

          <p class="text-content3">{{ $t('multipleDevicesContent') }}</p>

           <div  @click="getNow()">
            {{ $t('getNow') }}
          </div>
        </div>
      </div>
    </div>

    <div class="container evaluate">
      <div class="content">
        <h2 class="title">{{ $t('evaluate')}}</h2>
        <div class="evaluate-box">
          <img class="left-btn" src="/static/img/newhome_img/leftarrow.png" alt="">
          <div class="evaluate-list">


          <ul class="evaluate-lists">
              <li>
              <img :src="lan == 'zh' ? imgdata.zh[0] : imgdata.en[0]" alt="">
              <h2>{{ $t('userName1')}}</h2>
              <p>{{ $t('userEvaluate1')}}</p>
            </li>
            <li>
              <img :src="lan == 'zh' ? imgdata.zh[1] : imgdata.en[1]" alt="">
              <h2>{{ $t('userName2')}}</h2>
              <p>{{ $t('userEvaluate2')}}</p>
            </li>
             <li>
              <img :src="lan == 'zh' ? imgdata.zh[2] : imgdata.en[2]" alt="">
              <h2>{{ $t('userName3')}}</h2>
              <p>{{ $t('userEvaluate3')}}</p>
            </li>
              <li>
              <img :src="lan == 'zh' ? imgdata.zh[3] : imgdata.en[3]" alt="">
              <h2>{{ $t('userName4')}}</h2>
              <p>{{ $t('userEvaluate4')}}</p>
            </li>
             <li>
              <img :src="lan == 'zh' ? imgdata.zh[4] : imgdata.en[4]" alt="">
              <h2>{{ $t('userName5')}}</h2>
              <p>{{ $t('userEvaluate5')}}</p>
            </li>
             <li>
              <img :src="lan == 'zh' ? imgdata.zh[5] : imgdata.en[5]" alt="">
              <h2>{{ $t('userName6')}}</h2>
              <p>{{ $t('userEvaluate6')}}</p>
            </li>
             <li>
              <img :src="lan == 'zh' ? imgdata.zh[6] : imgdata.en[6]" alt="">
              <h2>{{ $t('userName7')}}</h2>
              <p>{{ $t('userEvaluate7')}}</p>
            </li>
          </ul>
          </div>
          <img class="right-btn" src="/static/img/newhome_img/rightarrow.png" alt="">
        </div>
      </div>
    </div>

    </div>

    <slot></slot>
    <div class="container compatibility">
      <div class="content text-center">
        <p><router-link to="/download" class="download-btn">{{ $t('download') }}</router-link></p>
        <p>
          <router-link to="/download?platform=windows" class="download-link" aria-label="windows"><span><svg class="icon"><use xlink:href="#icon-windows"></use></svg></span></router-link>
          <router-link to="/download?platform=mac" class="download-link" aria-label="mac"><span><svg class="icon"><use xlink:href="#icon-Macos"></use></svg></span></router-link>
          <router-link to="/download?platform=ios" class="download-link" aria-label="ios"><span><svg class="icon"><use xlink:href="#icon-pingguo"></use></svg></span></router-link>
          <router-link to="/download?platform=android" class="download-link" aria-label="android"><span><svg class="icon"><use xlink:href="#icon-anzhuo"></use></svg></span></router-link>
          <router-link to="/download?platform=ubuntu" class="download-link" aria-label="ubuntu"><span><svg class="icon"><use xlink:href="#icon-Ubuntu"></use></svg></span></router-link>
          <router-link to="/download?platform=androidTV" class="download-link" aria-label="android_tv"><span><svg class="icon"><use xlink:href="#icon-androidTV"></use></svg></span></router-link>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  import Triangle from '../../../components/triangle/Triangle.vue'
  import GradientBtn from '../../../components/gradientBtn/GradientBtn.vue'
  import locales from './lang'

  export default {
    name: 'home-body-phone',
    components: {
      Triangle,
      GradientBtn
    },
    data: function () {
      return {
        isShowHeader: false,
        match: false,
        lan: '',
        imgdata: {
          zh:
          [
            'static/img/newhome_img/userwordzh1.png',
            'static/img/newhome_img/userwordzh2.png',
            'static/img/newhome_img/userwordzh3.png',
            'static/img/newhome_img/userwordzh4.png',
            'static/img/newhome_img/userwordzh5.png',
            'static/img/newhome_img/userwordzh6.png',
            'static/img/newhome_img/userwordzh7.png'
          ],
          en:
          [
            'static/img/newhome_img/userworden1.png',
            'static/img/newhome_img/userworden2.png',
            'static/img/newhome_img/userworden3.png',
            'static/img/newhome_img/userworden4.png',
            'static/img/newhome_img/userworden5.png',
            'static/img/newhome_img/userworden6.png',
            'static/img/newhome_img/userworden7.png'
          ]
        }
      }
    },
    locales,
    computed: {
      mediaType() {
        return this.$store.state.mediaType
      }
    },
    created() {
      this.match = window.matchMedia('(min-width: 991px)').matches
      window.addEventListener('scroll', this.showHeader)
    },
    mounted() {
      console.log(this.$store.state.mediaType)
      this.lan = window.localStorage.getItem('currentLang')
    },
    destroyed() {
      window.removeEventListener('scroll', this.showHeader)
    },
    methods: {
      showHeader: function () {
        if ($(window).scrollTop() >= 600) {
          this.isShowHeader = true
          this.$store.commit('setPhoneHeaderLogoFlag', true)
        } else {
          this.isShowHeader = false
          this.$store.commit('setPhoneHeaderLogoFlag', false)
        }
      },
      getNow: function () {
        if (this.$store.state.hasToken) {
          this.$router.push('/login')
        } else {
          this.$router.push('/dashboard')
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "homeBodyPhone";
</style>



// WEBPACK FOOTER //
// HomeBodyPhone.vue?18e7b336